var _path, _path2, _path3, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallcase(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 28 L32 20 L52 28 L32 36 Z",
    fill: "#C9A227"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 28 V44 L32 52 V36 Z",
    fill: "#1A2A52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52 28 V44 L32 52 V36 Z",
    fill: "#4A5A82"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#1A2A52"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#C9A227"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 2,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#4A5A82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallcase);
export default __webpack_public_path__ + "static/media/smallcase.093c75426d876124c59caa8ec2be9f1f.svg";
export { ForwardRef as ReactComponent };